import { Document, Packer, Paragraph, TextRun, ImageRun, WidthType, TableCell, Table, TableRow, convertInchesToTwip, BorderStyle, Underline } from "docx";
import { saveAs } from "file-saver";
import pdfImage from "../../components/PDF/pdfImage";

export const RPT234Word = (dataReport, setLoading) => {
    const font = {
        size: {
            p: 28,
            tbHeader: 28,
            tbbody: 28,
        },
        SarabunPSK: "TH SarabunPSK",
    };

    const cellBorder = {
        noBorder: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
        line: { top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }, right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" } },
    };
    const tb1 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        verticalAlign: "center",
                        borders: cellBorder.noBorder,
                        margins: {
                            right: convertInchesToTwip(0.8),
                        },
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "right",
                                children: [
                                    new ImageRun({
                                        data: pdfImage.logo_2,
                                        transformation: {
                                            width: 100,
                                            height: 100,
                                        },
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: { top: convertInchesToTwip(0.2), bottom: convertInchesToTwip(0.2) },
                        width: {
                            size: convertInchesToTwip(2),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Table({
                                rows: [
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(2.5),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "เลขที่สัญญา " + dataReport.contractNo,
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                    new TableRow({
                                        children: [
                                            new TableCell({
                                                width: {
                                                    size: convertInchesToTwip(3),
                                                    type: WidthType.DXA,
                                                },
                                                children: [
                                                    new Paragraph({
                                                        alignment: "left",
                                                        children: [
                                                            new TextRun({
                                                                size: font.size.tbbody,
                                                                text: "งวดที่ " + dataReport.withdrawSeq, // "  (ครั้งสุดท้าย) ", มาจาก swagger
                                                                font: font.SarabunPSK,
                                                            }),
                                                        ],
                                                    }),
                                                ],
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const p1 = new Paragraph({
        alignment: "center",
        children: [
            new TextRun({
                text: "ใบสรุปการขอเบิกจ่ายเงินค่างานก่อสร้าง งวดที่  " + dataReport.withdrawSeq + "  (งวดสุดท้าย)",
                bold: true,
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });

    const tb2 = new Table({
        borders: cellBorder.noBorder,
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: {
                            left: convertInchesToTwip(0.5),
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(0.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "right",
                                children: [
                                    new TextRun({
                                        text: "เลขที่  ",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(2),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: dataReport.p2LetterNo,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: {
                            left: convertInchesToTwip(0.5),
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(3),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "วันที่  " + dataReport.p2LetterDate,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const tb3 = new Table({
        borders: cellBorder.noBorder,
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: {
                            left: convertInchesToTwip(0.5),
                        },
                        verticalAlign: "center",
                        width: {
                            size: convertInchesToTwip(0.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "right",
                                children: [
                                    new TextRun({
                                        text: "เรียน",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        verticalAlign: "left",
                        margins: { left: convertInchesToTwip(0.3) },
                        width: {
                            size: convertInchesToTwip(0.0),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: dataReport.p2LetterTo,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const tb4 = new Table({
        borders: cellBorder.noBorder,
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: {
                            left: convertInchesToTwip(0.5),
                        },
                        width: {
                            size: convertInchesToTwip(0.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "ผู้ควบคุมงานเลขที่สัญญา",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: { left: convertInchesToTwip(0.3) },
                        width: {
                            size: convertInchesToTwip(3),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: dataReport.contractNo,
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(3),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: "ได้ตรวจสอบใบแจ้งหนี้",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const tb5 = new Table({
        borders: cellBorder.noBorder,
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: {
                            left: convertInchesToTwip(0.5),
                        },
                        width: {
                            size: convertInchesToTwip(9.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "ใบการเบิกจ่ายเงินค่างานก่อสร้างของผู้รับจ้างแล้ว  ขอรับรองว่าถูกต้องสอดคล้องกับรายละเอียดงานก่อสร้างตามแบบฟอร์ม P-1",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const tb6 = new Table({
        borders: cellBorder.noBorder,
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: {
                            left: convertInchesToTwip(0.5),
                        },
                        width: {
                            size: convertInchesToTwip(9.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "ของ  " + dataReport.contractorInfo + "  รวมจำนวน  " + dataReport.totalRoute + "  เส้นทาง  ตามใบแจ้งหนี้ผู้รับจ้างเลขที่  " + (dataReport.invoiceNo == null ? "" : dataReport.invoiceNo),
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const tb7 = new Table({
        borders: cellBorder.noBorder,
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: {
                            left: convertInchesToTwip(0.5),
                        },
                        width: {
                            size: convertInchesToTwip(9.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "ลงวันที่  " + dataReport.invoiceDate + "  ดังนี้",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const tb8 = new Table({
        borders: cellBorder.noBorder,
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        margins: {
                            left: convertInchesToTwip(0.5),
                        },
                        width: {
                            size: convertInchesToTwip(9.5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: "สรุปค่างานที่ขอเบิก - จ่ายในงวดนี้",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    // begin table point
    const tb9 = new Table({
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(6),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "รายการ",
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        width: {
                            size: convertInchesToTwip(4),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "จำนวน (บาท)",
                                        size: font.size.tbHeader,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const temp = [
        {
            itemDesc: dataReport.item1Desc,
            itemValue: dataReport.item1Value,
        },
        {
            itemDesc: dataReport.item2Desc,
            itemValue: dataReport.item2Value,
        },
        {
            itemDesc: dataReport.item3Desc,
            itemValue: dataReport.item3Value,
        },
        {
            itemDesc: dataReport.item4Desc,
            itemValue: dataReport.item4Value,
        },
        {
            itemDesc: dataReport.item5Desc,
            itemValue: dataReport.item5Value,
        },
        {
            itemDesc: dataReport.item6Desc,
            itemValue: dataReport.item6Value,
        },
        {
            itemDesc: dataReport.item7Desc,
            itemValue: dataReport.item7Value,
        },
        {
            itemDesc: dataReport.item8Desc,
            itemValue: dataReport.item8Value,
        },
        {
            itemDesc: dataReport.item9Desc,
            itemValue: dataReport.item9Value,
        },
        {
            itemDesc: "ยอดรวมขอเบิก - จ่าย งวดนี้",
            itemValue: dataReport.itemTotalValue,
        },
    ];

    for (const item of temp) {
        if (item.itemDesc != null) {
            tb9.root.push(
                new TableRow({
                    children: [
                        new TableCell({
                            margins: { left: convertInchesToTwip(0.2) },
                            width: {
                                size: convertInchesToTwip(6),
                                type: WidthType.DXA,
                            },
                            children: [
                                new Paragraph({
                                    alignment: "left",
                                    children: [
                                        new TextRun({
                                            text: item.itemDesc,
                                            size: font.size.tbbody,
                                            font: font.SarabunPSK,
                                        }),
                                    ],
                                }),
                            ],
                        }),
                        new TableCell({
                            width: {
                                size: convertInchesToTwip(4),
                                type: WidthType.DXA,
                            },
                            children: [
                                new Paragraph({
                                    alignment: "center",
                                    children: [
                                        new TextRun({
                                            text: item.itemValue,
                                            size: font.size.tbbody,
                                            font: font.SarabunPSK,
                                        }),
                                    ],
                                }),
                            ],
                        }),
                    ],
                })
            );
        }
    }
    // end table point

    const p2 = new Paragraph({
        alignment: "center",
        children: [
            new TextRun({
                text: "จึงเรียนมาเพื่อโปรดพิจารณา  อนุมัติการขอเบิกจ่ายเงินค่างาน  และสั่งการ  ฝกง. ดำเนินการเบิกจ่ายเงินค่างานให้ผู้รับจ้าง ต่อไป",
                size: font.size.p,
                font: font.SarabunPSK,
            }),
        ],
    });

    const tb10 = new Table({
        borders: cellBorder.noBorder,
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ลงนาม  ...............................",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "( " + dataReport.supervisorName + " )",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: " " + dataReport.supervisorTitle + " ",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: " ผู้คุมงาน ",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    });

    const tb11 = new Table({
        borders: cellBorder.noBorder,
        rows: [
            new TableRow({
                children: [
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: "อนุมัติ",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                            new Paragraph({
                                alignment: "left",
                                children: [
                                    new TextRun({
                                        text: "เรียน ผอ.ฝกง",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: " เพื่อโปรดดำเนินการเบิก จ่ายเงินให้ผู้รับจ้าง ต่อไป ",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: " ลงนาม ............................... ",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "( ............................... )",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                            new Paragraph({
                                alignment: "center",
                                children: [
                                    new TextRun({
                                        text: "ผจ.สส.. / ขวก.(ก...) / รวก.(กอ) / ขวก.(กต) / ขวก.(บ) / รวก.(บ) ",
                                        size: font.size.tbbody,
                                        font: font.SarabunPSK,
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableCell({
                        borders: cellBorder.noBorder,
                        width: {
                            size: convertInchesToTwip(5),
                            type: WidthType.DXA,
                        },
                        children: [],
                    }),
                ],
            }),
        ],
    });

    const space = new Paragraph({
        children: [],
    });

    const doc = new Document({
        sections: [
            {
                children: [tb1, p1, tb2, space, tb3, space, tb4, space, tb5, space, tb6, space, tb7, space, tb8, space, tb9, space, p2, tb10, space, tb11],
                properties: {
                    page: {
                        margin: {
                            top: convertInchesToTwip(0.5),
                            right: convertInchesToTwip(0.5),
                            bottom: convertInchesToTwip(0.5),
                            left: convertInchesToTwip(0.5),
                        },
                    },
                    type: WidthType.DXA,
                },
            },
        ],
    });

    Packer.toBlob(doc).then((blob) => {
        setLoading(false);
        saveAs(blob, "PRT234.docx");
    });
};
